import type { ErrorType } from '~/data/ErrorRecord';

export const defaultState: Fields = {
  isLoading: false,
  isChanged: false,
  modalIsOpen: false,
  machineId: '',
  machineName: '',
  error: undefined,
};

export interface Fields {
  isLoading: boolean;
  isChanged: boolean;
  modalIsOpen: boolean;
  machineId: string;
  machineName: string;
  error?: ErrorType;
}
